/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { isManagerCompany } from '../../../utils/auth';
import { isEmpty } from '../../../utils/lodashExtend';
import { ColCard, Row } from '../../ContentLayout';
import DataComponent from '../../DataComponent';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setTaxContactType as _setTaxContactType } from "../../../store/actions";
import { classnames } from '../../../utils/text';
import { TAX_CONTACT_TYPES } from '../../../constants/TaxPortal/TAX_CONTACT_TYPE';

const TaxContacts = () => {
  const dispatch = useDispatch();

  const [taxContactTypeList, setTaxContactTypeList] = useState([]);
  const {
    taxContactType,
    managerRole,
  } = useSelector(
    (store) => ({
      taxContactType: store.TaxPortal.taxContactType,
      managerRole: store.Profile.managerRole,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (managerRole) {

      const isTaxAdmin = managerRole?.type === 1 || managerRole?.type === 2;
      setTaxContactTypeList(TAX_CONTACT_TYPES);
      // setTaxContactTypeList(isTaxAdmin ? TAX_CONTACT_TYPES : TAX_CONTACT_TYPES.slice(1));
      isTaxAdmin && setTaxContactType("ALL");
    }
  }, [managerRole]);

  const setTaxContactType = (type) => {
    dispatch(_setTaxContactType(type));
  };

  return (
    <>
      {
        isManagerCompany() &&
        !isEmpty(taxContactTypeList) && taxContactType && <>
          <div className="tax-portal">
            <Row>
              <ColCard type="light" className={"tax-portal-tab"}>
                {taxContactTypeList.map(({ label, icon, id }, idx) => (
                  <DataComponent
                    key={idx}
                    field={{
                      className: classnames({
                        active: taxContactType === id,
                      }),
                      type: "button",
                      color: "text",
                      label: (
                        <>
                          {/* <Icon src={icon} /> */}
                          {label}
                        </>
                      ),
                      action: () => {
                        setTaxContactType(id);
                      },
                    }}
                  />
                ))}
              </ColCard>
            </Row>
          </div>
        </>
      }
    </>
  );
};

export default TaxContacts;